import { Component, OnInit, Input } from '@angular/core';
import { E5coreUiTimePickerBaseComponent } from './e5core-ui-timepicker-base.component';

@Component({
  selector: 'e5core-ui-timepicker-material',
  templateUrl: './e5core-ui-timepicker-material.component.html',
  styleUrls: ['./e5core-ui-timepicker-material.component.css']
})
export class E5coreUiTimepickerMaterialComponent extends E5coreUiTimePickerBaseComponent {
  
    @Input() public displayedTime: string;
    currentHours:number;
    currentMinutes: number;
    
    // ngOnInit() {
    //   this.currentTime = new Date();
    //   this.currentHours = this.currentTime.getHours();
    //   this.currentMinutes = this.currentTime.getMinutes();
    // }
}
